import { render, staticRenderFns } from "./ProductionReceiptForm.vue?vue&type=template&id=0c4c57ca&scoped=true"
import script from "./ProductionReceiptForm.vue?vue&type=script&lang=js"
export * from "./ProductionReceiptForm.vue?vue&type=script&lang=js"
import style0 from "./ProductionReceiptForm.vue?vue&type=style&index=0&id=0c4c57ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c57ca",
  null
  
)

export default component.exports